import RichText from "./RichText";
import Image from "./Image";
import TwoImages from "./TwoImages";
import Carousel from "./Carousel/Carousel";
import FrontpageHero from "./FrontpageHero";
import Quote from "./Quote";
import ActivityFactBox from "./ActivityFactBox";
import Accordion from "./Accordion";
import LinkList from "./LinkList";
import Tables from "./Tables";
import CheckList from "./CheckList";
import FactBox from "./FactBox";
import Video from "./Video";
import Numbers from "./Numbers";
import GreenBoxLink from "./GreenBoxLink";
import LogoLinkList from "./LogoLinkList";
import EventCalendar from "./EventCalendar";

export default {
  rich_text: RichText,
  image: Image,
  two_images: TwoImages,
  carousel: Carousel,
  frontpage_hero: FrontpageHero,
  quote: Quote,
  activity_fact_box: ActivityFactBox,
  accordion: Accordion,
  link_list: LinkList,
  tables: Tables,
  check_list: CheckList,
  fact_box: FactBox,
  video: Video,
  numbers: Numbers,
  green_box_link: GreenBoxLink,
  logo_link_list: LogoLinkList,
  event_calendar: EventCalendar,
};
